import React from "react";
import { Container } from "reactstrap";
import styled from "styled-components";
import ClearDarkBronze from "./images/Showers/ClearDarkBronze.jpg";
import ClearHalfWall from "./images/Showers/ClearHalfWall.jpg";
import ClearSeat from "./images/Showers/ClearSeat.jpg";
import CornerAngle from "./images/Showers/CornerAngle.jpg";
import CornerClear from "./images/Showers/CornerClear.jpg";
import CornerThreePanel from "./images/Showers/CornerThreePanel.jpg";
import EstateSlider from "./images/Showers/EstateSlider.jpg";
import FramelessFrosted from "./images/Showers/FramlessFrosted.jpg";
// import Frosted from "./images/Showers/Frosted.jpg"
import StoneShower from "./images/Showers/StoneShower.jpg";

const Frame = styled.div`
  width: 100%;
  padding: 20px 0;
  margin-bottom: 20px;
  display: flex;
  background: whitesmoke;
  justify-content: space-around;
  flex-wrap: wrap;
`;

const Media = styled.div`margin: 5px;`;
const SliderImg = styled.img`
  width: 300px;
  max-width: 100%;
  max-height: 600px;
`;

const Showers = props => {
  return (
    <Container>
      <h2>Custom Showers by Majestic Showers</h2>
      <hr />
 
      <p>Majestic Showers by Red River Glazing add an elegant custom touch to your bathroom. Whether you are adding a new shower or renovating an existing enclosure our expert sales and installation team is ready to help you with your custom design.</p>

      <p>We carry framed or frameless shower enclosures which come in many styles. You will be able to choose from different glass patterns, tints, thickness, and frame colors. Please feel free to visit one of our locations where we have examples of some of the most popular styles already built.</p>
   
      <p>In addition to the showers themselves, we also carry many shower related accessories. These include glass shelving, towel bars, robe hooks, and cleaning supplies.</p>
 
      <h3>Please see some of our recent work below or visit our <a href="https://www.facebook.com/redriverglazing">Facebook Page</a>:</h3>
      <Frame>
        <Media>
          <SliderImg src={ClearDarkBronze} />
        </Media>
        <Media>
          <SliderImg src={ClearHalfWall} />
        </Media>
        <Media>
          <SliderImg src={ClearSeat} />
        </Media>
        <Media>
          <SliderImg src={CornerAngle} />
        </Media>
        <Media>
          <SliderImg src={CornerClear} />
        </Media>
        <Media>
          <SliderImg src={CornerThreePanel} />
        </Media>
        <Media>
          <SliderImg src={EstateSlider} />
        </Media>
        <Media>
          <SliderImg src={FramelessFrosted} />
        </Media>
        <Media>
          <SliderImg src={StoneShower} />
        </Media>
      </Frame>
    </Container>
  );
};

export default Showers;



// WEBPACK FOOTER //
// ./src/Showers.js